import { Outlet } from 'react-router-dom'

const SkillEnhancement = () => {
  return (
    <>
    <div><Outlet /></div></>
  )
}

export default SkillEnhancement